import Vue from "vue";
import excel from "vue-excel-export";
import breadcrumbComp from "../../../common/breadcrumb-comp.vue";
import EncryptUtility from "../../../../components/utility/js/encrypt-utility";
import AddFavourite from "../../../utility/js/addFav";
import Utility from "../../../../shared/utility";
import exportLimit from "../../../common/export-limit.vue";
import inventoryService from "../../js/inventory-service";
import router from "../../../../router/router";
Vue.use(excel);
export default {
  data: () => ({
    mainPage: "",
    subPage: "",
    excelFileName: "",
    compCalled: false,
    showAdd: false,
    favouriteList: [],
    isFormValid: false,
    actionList: [],
    totalRecords: 0,
    json_fields: {
      Scope: "Scope",
      Project: "Project",
      Type: "Type",
      Status: "Status ",
    },
    userId: EncryptUtility.localStorageDecrypt("userID"),
    refresh: true,
    projectList: [],
    scopeList: [],
    statusList: [],
    scopeDataList: [],
    search: "",
    scopeListHeader: [
      {
        text: "Scope",
        align: "start",
        value: "Scope",
        class: "primary customwhite--text",
      },
      {
        text: "Project",
        align: "start",
        value: "Project",
        class: "primary customwhite--text",
      },
      {
        text: "Type",
        align: "start",
        value: "Type",
        class: "primary customwhite--text",
      },
      {
        text: "Status",
        align: "start",
        value: "Status",
        class: "primary customwhite--text",
      },
      {
        text: "Actions",
        value: "actions",
        class: "primary customwhite--text",
      },
    ],
    backSlash: true,
    searchObj: {
      user_id: 0,
      proj_id: 0,
      status_id: 0,
      pi_type_id: 0,
      search: "",
    },
  }),
  async created() {
    this.searchObj.user_id = this.userId;
    this.route = this.$route.path.replace("/", "");
    let data = await AddFavourite.getPageAction(this.userId, this.route);
    this.actionList = data.actionList;
    this.mainPage = data.mainPage;
    this.favouriteList = data.favouriteList;
    this.pageUrl = data.pageUrl;
    this.subPage = data.subPage;
    this.showAdd = data.showAdd;
  },
  async mounted() {
    let resp = await inventoryService.getInitalList("get", this.userId);
    this.projectList = resp.Projects;
    this.statusList = resp.Scope;
    this.scopeList = resp.Type;
    this.getSearch();
    router.afterEach((to) => {
      if (!to.path.includes("scope-manager-add") && !to.path.includes("scope-manager-edit") && !to.path.includes("scope-manager-list")) {
        EncryptUtility.localStorageRemoveItem("SLSearchString");
        EncryptUtility.localStorageRemoveItem("SLProject");
        EncryptUtility.localStorageRemoveItem("SLProjectData");
        EncryptUtility.localStorageRemoveItem("SLScopeType");
        EncryptUtility.localStorageRemoveItem("SLScopeTypeData");
        EncryptUtility.localStorageRemoveItem("SLStatus");
        EncryptUtility.localStorageRemoveItem("SLStatusData");
      }
    });
  },
  methods: {
    actionSetter(action) {
      return Utility.actionSetter(this.actionList, action);
    },
    onClickAddScope() {
      this.$router.push(`/scope-manager-add`);
    },
    //Loading Local Storage items for search persistance
    getSearch() {
      if (EncryptUtility.localStorageDecrypt("SLSearchString") !== null && EncryptUtility.localStorageDecrypt("SLSearchString") !== undefined) {
        this.searchObj.search = EncryptUtility.localStorageDecrypt("SLSearchString");
      }
      if (EncryptUtility.localStorageDecrypt("SLProject") !== null && EncryptUtility.localStorageDecrypt("SLProject") !== undefined) {
        this.searchObj.proj_id = parseInt(EncryptUtility.localStorageDecrypt("SLProject"));
        this.projectList = JSON.parse(EncryptUtility.localStorageDecrypt("SLProjectData"));
      }
      if (EncryptUtility.localStorageDecrypt("SLScopeType") !== null && EncryptUtility.localStorageDecrypt("SLScopeType") !== undefined) {
        this.searchObj.pi_type_id = parseInt(EncryptUtility.localStorageDecrypt("SLScopeType"));
        this.scopeList = JSON.parse(EncryptUtility.localStorageDecrypt("SLScopeTypeData"));
      }
      if (EncryptUtility.localStorageDecrypt("SLStatus") !== null && EncryptUtility.localStorageDecrypt("SLStatus") !== undefined) {
        this.searchObj.status_id = parseInt(EncryptUtility.localStorageDecrypt("SLStatus"));
        this.statusList = JSON.parse(EncryptUtility.localStorageDecrypt("SLStatusData"));
      }
      this.onClickSearch();
    },
    async onClickSearch() {
      let resp = await inventoryService.postSearch("post", this.searchObj, false);
      if (resp !== undefined) {
        this.scopeDataList = resp;
        this.totalRecords = resp?.length;
        if (this.searchObj.search !== "") {
          EncryptUtility.localStorageEncrypt("SLSearchString", this.searchObj.search.toString());
        }
      } else {
        this.totalRecords = 0;
        this.scopeDataList = [];
      }
    },
    onClickCancel() {
      this.searchObj = {
        search: "",
        user_id: this.userId,
        proj_id: 0,
        status_id: 0,
        pi_type_id: 0,
      };
      this.scopeDataList = [];
      this.totalRecords = 0;
    },
    fileName() {
      this.excelFileName = Utility.excelFileName("Scope");
      return;
    },
    onClickEdit(item) {
      this.$router.push(`/scope-manager-edit/${btoa(item.control_id.toString())}`);
    },
    //On Project Selected
    onProjectSelect() {
      if (this.searchObj.proj_id !== null && this.searchObj.proj_id !== undefined) {
        EncryptUtility.localStorageEncrypt("SLProject", this.searchObj.proj_id.toString());
        if (this.projectList.length !== 0) {
          EncryptUtility.localStorageEncrypt("SLProjectData", JSON.stringify(this.projectList));
        }
      }
    },
    //On Scope Type Selected
    onScopeTypeSelect() {
      if (this.searchObj.pi_type_id !== null && this.searchObj.pi_type_id !== undefined) {
        EncryptUtility.localStorageEncrypt("SLScopeType", this.searchObj.pi_type_id.toString());
        if (this.scopeList.length !== 0) {
          EncryptUtility.localStorageEncrypt("SLScopeTypeData", JSON.stringify(this.scopeList));
        }
      }
    },
    //On Status Selected
    onStatusSelect() {
      if (this.searchObj.status_id !== null && this.searchObj.status_id !== undefined) {
        EncryptUtility.localStorageEncrypt("SLStatus", this.searchObj.status_id.toString());
        if (this.statusList.length !== 0) {
          EncryptUtility.localStorageEncrypt("SLStatusData", JSON.stringify(this.statusList));
        }
      }
    },
  },
  components: {
    breadcrumbComp,
    exportLimit,
  },
};
